import api from '../services/api';
import { liveIvrEnvironment } from '../services/liveIvrEnvironment';
import { localDemoEnvironment } from './localDemoEnvironment';

// Only the exact private reviewer pair or the explicit loopback demo disables ordering.
// This does not classify patient records or change the separate live IVR capability gate.
export function demoOrderingEnvironment({
  webOrigin = window.location.origin,
  apiBase = api.defaults?.baseURL,
  localEnabled = process.env.REACT_APP_LOCAL_DEMO_SESSION,
} = {}) {
  return (
    liveIvrEnvironment({ webOrigin, apiBase, localQa: false }).allowed ||
    localDemoEnvironment({ enabled: localEnabled, webOrigin, apiUrl: apiBase })
  );
}
